import React from "react";

const LogoutButton = ({className}) => {
    const handleLogout = async (event) => {
        if (window.Verisoul) {
            await window.Verisoul.reinitialize();
        }
    };

    return (
        <a
            href={`/accounts/logout/?next=/`}
            className={className}
            onClick={handleLogout}
        >
            Logout
        </a>
    )

}

export default LogoutButton